export default "__VITE_ASSET__Dpej9uK1__"